import { Alert, Dialog, Step, 
	StepButton, StepLabel, Stepper, 
	Tooltip 
} from "@mui/material";

import { useRuleWizardContext } from "../../../providers/RuleWizardProvider";
import { CoAppActionButton, CoAppCancelTextButton } from "../../global/styled/global.styled";
import { WizardStepConnector, WizardStepperContainer } from "../styled/rule-wizard.styled";

import WizardStepIcon from "./WizardStepIcon";

export default function WizardStepper() {
	const { activeStep, getSteps, stepsCompleted, handleComplete, handleSubmit, handleBack, wizardFormError, setWizardFormError } = useRuleWizardContext();

	const steps = getSteps();

	return (
		<WizardStepperContainer direction="row">
			<Stepper connector={<WizardStepConnector />} alternativeLabel nonLinear activeStep={activeStep} sx={{ width: "50%" }}>
				{steps.map(step => (
					<Step completed={stepsCompleted[step.num]} key={step.num}>
						<Tooltip title={step.desc} placement="top">
							<StepButton onClick={() => handleSubmit(step.num)}>
								{/* Fix Deprecation */}
								<StepLabel StepIconComponent={WizardStepIcon}>{step.desc}</StepLabel>
							</StepButton>
						</Tooltip>
					</Step>
				))}
			</Stepper>


			<CoAppCancelTextButton className="StepButton" onClick={handleBack} disabled={activeStep === 0}>
				Back
			</CoAppCancelTextButton>

			{activeStep === 4 ? (
				<CoAppActionButton className="StepButton" onClick={handleComplete}>
					Finish
				</CoAppActionButton>
			) : (
				<CoAppActionButton className="StepButton" onClick={() => handleSubmit(activeStep + 1)}>
					Next
				</CoAppActionButton>
			)}
			<Dialog onClose={() => setWizardFormError("")} open={wizardFormError !== ""}>
				<Alert severity="error">{wizardFormError}</Alert>
			</Dialog>
		</WizardStepperContainer>
	);
}